var exports = {
  "k": "xfd349460--a6aab8--container",
  "p": "xfd349460--a6aab8--list",
};

module.exports = exports;
